<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:วัน-เวลาเริ่มทำ PM -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วัน-เวลาเริ่มทำ PM :</label>
                <span class="form-control-plaintext">{{ pmStartDate }}</span>
              </div>
            </div>
            <!-- End:วัน-เวลาเริ่มทำ PM -->

            <!-- Begin:วัน-เวลาสิ้นสุดการทำ PM -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วัน-เวลาสิ้นสุดการทำ PM :</label>
                <span class="form-control-plaintext">{{ pmEndDate }}</span>
              </div>
            </div>
            <!-- End:วัน-เวลาสิ้นสุดการทำ PM -->

            <!-- Begin:ระยะเวลาในการทำ PM -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ระยะเวลาในการทำ PM (นาที) :</label>
                <span class="form-control-plaintext">{{ diffMins }}</span>
              </div>
            </div>
            <!-- End:ระยะเวลาในการทำ PM -->

            <!-- Begin:ชื่อ-สกุลผู้ทำ PM -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ทำ PM :</label>
                <span class="form-control-plaintext">{{ createUser }}</span>
              </div>
            </div>
            <!-- End:ชื่อ-สกุลผู้ทำ PM -->

            <!-- Begin:รูปลายเซ็นต์-->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">รูปลายเซ็นต์ :</label>
                <br />
                <a
                  href="#"
                  @click.prevent="pictureModal(signatureFileUrl,signatureFileInfo)"
                  title="รูปภาพ"
                  v-if="signatureFileUrl && !isImgCloud"
                  >Link</a
                >
                <a
                            href="javascript:void(0);"
                             @click="showModal(signatureFileUrl,signatureFileInfo)"
                            title="รูปภาพ"
                            v-if="signatureFileUrl != null && isImgCloud"
                            >Link </a
                          > 
              </div>
            </div>
            <!-- End:รูปลายเซ็นต์ -->
          </div>
          <hr />
          <!-- machineSpares -->
          <div v-if="machineSpares.length > 0">
            <div
              class="kt-section kt-section--first"
              v-for="(ms, i) in machineSpares"
              :key="i"
            >
              <!-- การเปลี่ยนอะไหล่ เครื่องทำความเย็น -->
              <div v-if="ms.surveys.length > 0">
                <h3 class="kt-section__title">
                  การเปลี่ยนอะไหล่ เครื่องทำความเย็น:
                </h3>
                <div class="kt-section__body">
                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="15%">หัวข้อ</th>
                            <th class="text-center" width="15%">คำตอบ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(msur, i) in ms.surveys" :key="i">
                            <td class="text-center stock-item-td">
                              {{ i + 1 }}
                            </td>
                            <td class="stock-item-td text-left">
                              {{ msur.questionText }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ msur.answerText }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- รายการอะไหล่ เครื่องทำความเย็น -->
              <div v-if="ms.spares.length > 0">
                <h3 class="kt-section__title">
                  รายการอะไหล่ เครื่องทำความเย็น:
                </h3>
                <div class="kt-section__body">
                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="15%">ชื่ออะไหล่</th>
                            <th class="text-center" width="5%">จำนวน</th>
                            <th class="text-center" width="15%">
                              วันที่เปลี่ยน
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(msp, i) in ms.spares" :key="i">
                            <td class="text-center stock-item-td">
                              {{ i + 1 }}
                            </td>
                            <td class="stock-item-td text-left">
                              {{ msp.materialName }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ msp.amount }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ msp.changeDate }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- dispensers -->
          <div v-if="dispensers.length > 0">
            <div
              class="kt-section kt-section--first"
              v-for="(d, i) in dispensers"
              :key="i"
            >
              <hr />
              <!-- การทำความสะอาด เครื่องทำความเย็น -->
              <div v-if="d.cleanUps.length > 0">
                <h3 class="kt-section__title">
                  การทำความสะอาด เฉพาะหัวจ่ายนี้ ({{ d.productBrandName }}):
                </h3>
                <div class="kt-section__body">
                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="15%">หัวข้อ</th>
                            <th class="text-center" width="5%">รูป</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(dc, i) in d.cleanUps" :key="i">
                            <td class="text-center stock-item-td">
                              {{ i + 1 }}
                            </td>
                            <td class="stock-item-td text-left">
                              {{ dc.cleanUpChoiceName }}
                            </td>
                            <td class="text-center stock-item-td">
                             
                              <a
                                href="#"
                                @click.prevent="pictureModal(dc.fileUrl,dc.fileInfoId)"
                                title="รูปภาพ"
                                v-if="dc.fileUrl && !dc.isImgCloud"
                                >Link</a
                              >
                              <a
                            href="javascript:void(0);"
                             @click="showModal(dc.fileUrl,dc.fileInfoId)"
                            title="รูปภาพ"
                            v-if="dc.fileUrl != null && dc.isImgCloud"
                            >Link </a
                          >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- การเปลี่ยนอะไหล่ เฉพาะหัวจ่ายนี้ -->
              <div v-if="d.surveys.length > 0">
                <h3 class="kt-section__title">
                  การเปลี่ยนอะไหล่ เฉพาะหัวจ่ายนี้ ({{ d.productBrandName }}):
                </h3>
                <div class="kt-section__body">
                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="15%">หัวข้อ</th>
                            <th class="text-center" width="15%">คำตอบ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(dsur, i) in d.surveys" :key="i">
                            <td class="text-center stock-item-td">
                              {{ i + 1 }}
                            </td>
                            <td class="stock-item-td text-left">
                              {{ dsur.questionText }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ dsur.answerText }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- รายการอะไหล่ เครื่องทำความเย็น -->
              <div v-if="d.spares.length > 0">
                <h3 class="kt-section__title">
                  รายการอะไหล่ เฉพาะหัวจ่ายนี้ ({{ d.productBrandName }}):
                </h3>
                <div class="kt-section__body">
                  <div class="row">
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" width="5%">ลำดับ</th>
                            <th class="text-center" width="15%">ชื่ออะไหล่</th>
                            <th class="text-center" width="5%">จำนวน</th>
                            <th class="text-center" width="15%">
                              วันที่เปลี่ยน
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(dsp, i) in d.spares" :key="i">
                            <td class="text-center stock-item-td">
                              {{ i + 1 }}
                            </td>
                            <td class="stock-item-td text-left">
                              {{ dsp.materialName }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ dsp.amount }}
                            </td>
                            <td class="text-center stock-item-td">
                              {{ dsp.changeDate }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content mr-4">
            <div class="modal-header">
              <h5 class="modal-title">ภาพถ่าย</h5>
              <button type="button" class="close" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body"> 
              <img :src="modalImageURL" class="img-thumbnail mb-3" style="height: auto; width: auto;"> 
            </div>
            <div class="modal-footer">
            <a 
                               class="btn btn-secondary"  
                              target="blank"
                              :href="`/Api/File/DownloadImage?FileInfoId=${modalImageFileInFo}`"
                              ><i class="fa fa-save"></i> ดาวน์โหลดรูปภาพ</a
                            >  
              <button type="button" data-dismiss="modal" class="btn btn-secondary"  aria-label="Close" @click="closeModal"><i class="la la-close"></i> ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var self = this;
    return {
      modalImageURL: '',
      modalImageFileInfo: '',
      pmStartDate: null,
      pmEndDate: null,
      signatureFileUrl: null,
      signatureFileInfo: null,
      diffMins: null,
      createUser: null,
      machineSpares: [],
      dispensers: [],
      barcodeShopMappingId: null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .post("/Api/PM/PMDetail", {
        BarcodeShopMappingId: this.$route.params.id2,
        PMCheckInId: this.$route.params.id,
      })
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data.data.length);
          if (response.data) {
            self.pmStartDate = response.data.pmStartDateFormat;
            self.pmEndDate = response.data.pmEndDateFormat;
            self.diffMins = response.data.diffMins;
            self.signatureFileUrl = response.data.signatureFileUrl;
            self.signatureFileInfo = response.data.signatureFileInfoId;
            self.createUser = response.data.createUser;
            self.isImgCloud =  response.data.isImgCloud ;

            if (response.data.set != null) {
              var s = response.data.set;

              //machineSpares
              let machineSpares = [];
              if (s.machineSpares != null && s.machineSpares.length > 0) {
                s.machineSpares.forEach((m) => {
                  //surveys
                  let surveys = [];
                  if (m.surveys != null && m.surveys.length > 0) {
                    m.surveys.forEach((sur) => {
                      surveys.push({
                        answerCode: sur.answerCode,
                        answerText: sur.answerText,
                        questionCode: sur.questionCode,
                        questionText: sur.questionText,
                        surveyDate: sur.surveyDateFormat,
                      });
                    });
                  }

                  //spares
                  let spares = [];
                  if (m.spares != null && m.spares.length > 0) {
                    m.spares.forEach((sp) => {
                      spares.push({
                        materialCode: sp.materialCode,
                        materialName: sp.materialName,
                        amount: sp.amount,
                        changeDate: sp.changeDateFormat,
                      });
                    });
                  }

                  machineSpares.push({
                    surveys: surveys,
                    spares: spares,
                  });
                });
              }

              //dispensers
              let dispensers = [];
              if (s.dispensers != null && s.dispensers.length > 0) {
                s.dispensers.forEach((d) => {
                  //surveys
                  let surveys = [];
                  if (d.surveys != null && d.surveys.length > 0) {
                    d.surveys.forEach((sur) => {
                      surveys.push({
                        answerCode: sur.answerCode,
                        answerText: sur.answerText,
                        questionCode: sur.questionCode,
                        questionText: sur.questionText,
                        surveyDate: sur.surveyDateFormat,
                      });
                    });
                  }

                  //spares
                  let spares = [];
                  if (d.spares != null && d.spares.length > 0) {
                    d.spares.forEach((sp) => {
                      spares.push({
                        materialCode: sp.materialCode,
                        materialName: sp.materialName,
                        amount: sp.amount,
                        changeDate: sp.changeDateFormat,
                      });
                    });
                  }

                  //cleanUps
                  let cleanUps = [];
                  if (d.cleanUps != null && d.cleanUps.length > 0) {
                    d.cleanUps.forEach((c) => {
                      cleanUps.push({
                        cleanUpChoiceCode: c.cleanUpChoiceCode,
                        cleanUpChoiceName: c.cleanUpChoiceName,
                        fileUrl: c.fileUrl,
                        fileInfoId: c.fileInfoId,
                         isImgCloud : c.isImgCloud  ,
                      });
                    });
                  }

                  dispensers.push({
                    productBrandId: d.productBrandId,
                    productBrandName: d.productBrandName,
                    surveys: surveys,
                    spares: spares,
                    cleanUps: cleanUps,
                  });
                });
              }
              self.machineSpares = machineSpares;
              self.dispensers = dispensers;
              self.barcodeShopMappingId = s.barcodeShopMappingId;
              //console.log(self.set);
            }
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการทำ PM", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการทำ PM ได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  methods: {
    showModal(imageURL,fileInfoId) {
  
    this.modalImageURL = imageURL;
    this.modalImageFileInFo = fileInfoId ;
    this.isFromImageModal = true;
    $('#imageModal').modal('show');
    $('#imageModal').on('hidden.bs.modal', () => {
      $('body').addClass('modal-open');
    });
  },
  closeModal() {
    $('#imageModal').modal('hide');
  },
   
    pictureModal(fileUrl,fileInfoId) {
      let router = this.$router;
       this.modalImageFileInFo = fileInfoId ;
      if (fileUrl != null) {
        router.push({
          path: `/PM/DownloadImage/${encodeURIComponent(fileUrl)}`,
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    },
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/PM/PMDetail.vue